import moment from 'moment'
import store from '@/store/store'

const mixins = {
  computed: {
    isAuthenticated() {
      return store.getters.isAuthenticated
    },

    getActiveComponent() {
      return this.$route.name
    },

    $gutter() {
      return 16 // Grid column gutter
    }
  },
  methods: {
    displayDate(d) {
      const date = moment(d)
      return date.isValid() ? date.format('DD/MM/YYYY') : 'N/A'
    },

    displayDateTime(d) {
      const date = moment(d)
      return date.isValid() ? date.format('DD/MM/YYYY HH:mm:ss') : 'N/A'
    },

    birthDate(day, month, year) {
      const date = moment(`${day}/${month}/${year}`, 'DD/MM/YYYY')
      return date.isValid() ? date.format('DD/MM/YYYY') : 'N/A'
    },

    errorNotification(message) {
      this.$notify({
        title: 'Error',
        message,
        type: 'error'
      })
    },

    successNotification(message) {
      this.$notify({
        title: 'Success',
        message,
        type: 'success'
      })
    }
  }
}

export default mixins
